import { createWebHistory, createRouter } from "vue-router";
import Index from "@/components/Index.vue";
import AboutUs from "@/components/AboutUs.vue";
import ContactUs from "@/components/ContactUs.vue";
import Login from "@/components/Login.vue";
import ProfileHeader from "@/components/ProfileHeader.vue";
import UserBilling from "@/components/UserBilling.vue";
import Profile from "@/components/Profile.vue";
import MyCourse from "@/components/MyCourse.vue";
import AddCard from "@/components/AddCard.vue";
import FeaturedCourse from "@/components/FeaturedCourses.vue";
import Tutorial from "@/components/Tutorial.vue";
import Course from "@/components/Course.vue";
import OrderSummary from "@/components/OrderSummary.vue";
import GiftHeader from "@/components/GiftHeader.vue";
import GiftHome from "@/components/GiftHome.vue";
import GiftDetail from "@/components/GiftDetail.vue";
import GiftPayment from "@/components/GiftPayment.vue";
import PrivateClass from "@/components/PrivateClass.vue";

const routes = [
    {
        path: "/",
        alias: ["/index"],
        name: "Index",
        component: Index,
    },
    {
        path: "/aboutUs",
        name: "AboutUs",
        component: AboutUs
    },
    {
        path: "/course",
        name: "Course",
        component: Course
    },
    {
        path: "/contactUs",
        name: "ContactUs",
        component: ContactUs
    },
    {
        path: "/featuredCourse",
        name: "FeaturedCourse",
        component: FeaturedCourse
    },
    {
        path: "/tutorial",
        name: "Tutorial",
        component: Tutorial
    },
    {
        path: "/login",
        name: "Login",
        component: Login
    },
    {
        path: "/userBilling",
        name: "UserBilling",
        component: UserBilling
    },
    {
        path: "/orderSummary",
        name: "OrderSummary",
        component: OrderSummary
    },
    {
        path: "/privateClass",
        name: "PrivateClass",
        component: PrivateClass
    },
    {
        path: '/user',
        component: ProfileHeader,
        redirect: '/user/Profile',
        meta: {
            auth: true
        },
        children: [
            {
                path: 'profile',
                name: 'Profile',
                component: Profile
            },
            {
                path: 'myCourse',
                name: 'MyCourse',
                component: MyCourse
            },
            {
                path: 'billing',
                name: 'UserBilling',
                component: UserBilling
            },
            {
                path: 'addCard',
                name: 'AddCard',
                component: AddCard
            },
        ]
    },
    {
        path: '/gift',
        component: GiftHeader,
        redirect: '/gift/home',
        /*
        meta: {
            requiresAuth: true
        },
        */
        children: [
            {
                path: 'home',
                name: 'GiftHome',
                component: GiftHome
            },
            {
                path: 'detail',
                name: 'GiftDetail',
                component: GiftDetail
            },
            {
                path: 'payment',
                name: 'GiftPayment',
                component: GiftPayment
            }
        ]
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        window.scrollTo(0, 0);
    }
});

export default router;
